import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/lib/api';
import { Card, ErrorText } from '@/components/ui';

export function AdminOverviewPage() {
  const api = useApi();
  const overview = useQuery({ queryKey: ['admin', 'overview'], queryFn: api.admin.overview });
  if (overview.isError) return <ErrorText error={overview.error} />;
  const d = overview.data;
  const tiles = [
    { label: 'Requests waiting', value: d?.pendingRequests, to: '/admin/requests' },
    { label: 'Organizations', value: d?.topLevelOrgs, to: '/admin/organizations' },
    { label: 'Users', value: d?.users, to: '/admin/users' },
  ];
  return (
    <div className="grid gap-4 sm:grid-cols-3">
      {tiles.map((t) => (
        <Link key={t.label} to={t.to}>
          <Card className="hover:border-primary">
            <p className="text-sm text-muted-foreground">{t.label}</p>
            <p className="mt-1 text-3xl font-semibold tabular-nums">{t.value ?? '–'}</p>
          </Card>
        </Link>
      ))}
    </div>
  );
}
